//( until env setup)

export const UNSPLASH_CONFIG = {
    BASE_URL: "https://api.unsplash.com",
    ACCESS_KEY:
        "a7201dc2e0f593d5afec59f5df5b8b5bd61c860877042f34d21078fade0469c8",
    PER_PAGE: 30,
    DEFAULT_QUERY: "nature",
};
export const PEXELS_CONFIG = {
    BASE_URL: "https://api.pexels.com/v1",
    ACCESS_KEY: "tQQFG7tTJ2wveurwxVybGyQGszsBsPoAur7Zk1EbJP9pNA5tiNlpwd1x",
    PER_PAGE: 30,
    DEFAULT_QUERY: "nature",
};
export const TENOR_CONFIG = {
    BASE_URL: "https://g.tenor.com/v1",
    ACCESS_KEY: "QMOXPYZL62ZY",
    LIMIT: 30,
    DEFAULT_QUERY: "nature",
};
export const PIXABAY_CONFIG = {
    BASE_URL: "https://botapi.qureal.com/proxies/pixabay",
    PER_PAGE: 50,
    DEFAULT_QUERY: "design",
};
